import { useSelector } from "react-redux";
import type { RootState } from "@src/reducers/store";

export const useIsChenHsongSouthAmericaNamespace = (): boolean => {
  const namespace = useSelector(
    (state: RootState) => state.yourSlice.authContext?.customerNamespace,
  );
  if (namespace) {
    return namespace === "2d326ad9-0c3c-41f3-9cda-d719eae17df6";
  }
  return false;
};
